import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { ReactComponent as My2NAppAccess } from '../../assets/my2n-app-access.svg';

function My2NAppAccessIcon({ ...props }: SvgIconProps) {
  return <SvgIcon component={My2NAppAccess} {...props} />;
}

export default My2NAppAccessIcon;
